/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/homepageUtilities.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/homepage-utilities.js
**/

/* global DetectTierTablet:true */
/* global DetectTierIphone:true */

/**
 *This is for all javascript code needed in Dream Miles homepage
 */
$(document).ready(function() {

	HomepageUtil.initializeHomepage();

});

var HomepageUtil = {};

HomepageUtil = (function() {

	var initializeHomepage = function() {

		initializeDatePickers();

		ValidationUtil.initialize();

		SearchFormValidator.initialize();

		MapUtil.initializeMap();

		initializeSidebarSlide();

		ListViewUtil.initializeSidebarHeightUpdater();

		SmartSuggestUtil.initialize();

		NumbersFieldUtil.initializeMilesFieldBehavior();

		SearchUtil.initAdvancedOptionsSlide();

		initBackToAllResultsLink();

		HomepageSortUtil.initSorting();

		setDatepickerHiddenText();

		initOverlayModal();

		oneWayDisablesReturnDate();

		aaWait.moduleId = 'interstitialBookOverlay';

		disableReturnIfOneWayIsSelected();

		initTooltips();
	};

	var initSidebarBookEvent = function($link) {
		$link.click(function() {
			var $form = $('#bookForm');
			$form.find('input[name="destination"]').val($(this).siblings('.destination').text());
			$form.submit();
			return false;
		});
	};

	var initializeSidebarSlide = function() {
	    var slideTab = $('#slide-tab');
	    slideTab.click(function() {
	            ListViewUtil.toggleSidebar();
	        });
	    slideTab.keyup(function(e) {
	            if ( e.keyCode == 13 ) {
	                ListViewUtil.toggleSidebar();
	            }
	        });
	};

	var initBackToAllResultsLink = function() {
		$('#showAllResults').click(function() {
			MapUtil.zoomToShowAllResults();
		});
	};

	var initTooltips = function() {
		var $is_touchDevice 	= (DetectTierTablet() || DetectTierIphone()) ? true: false;
		var $tooltip_trigger	= 'click';
		//aaTooltips.initTooltip({trigger: $tooltip_trigger, touchDevice: $is_touchDevice});
	    $('[data-behavior=tooltip-awardMap]').aaTooltip({
        			name: 'awardMap',
        			trigger: $tooltip_trigger,
        			touchDevice: $is_touchDevice
        		});
	};

	var initOverlayModal = function() {
		var height = $(window).height();
		var topPad = 20;
		var overlayPad = 70;
		var topbarHeight = $('#award-view-map').offset().top;
		var topbarHeightWithPadding = topbarHeight + 40;
		var top = topbarHeightWithPadding;
		var overlayHeight = $('#titleOverlay').height() + overlayPad;

		/*
		// not enough vertical room on window for overlay to be below
		// search bar, move it over search bar
		if(height && height < (topbarHeightWithPadding + overlayHeight)) {
			top = height - overlayHeight; // move overlay down as much as possible
			if(top < topPad)
				top = topPad;
		} else { // enough space, don't put overlay over top bar
			$('#lean_overlay').css('top', topbarHeight + 'px');
		}

		$("#overlayTrigger").leanModal({top: top, overlay: 0.85, closeButton: '#closeTitleOverlay, #topbar'});
		$('#overlayTrigger').click();
		$('#welcomeOverlayHeading').focus();
		*/

	    var aaUtil = new aa_Utilities();

	    //This is Jquery Dialog code for Mileage Multiplier Terms and conditions
	    aaUtil.aaDialog('titleOverlay',
	        {
	            width: 900,
	            height: 580,
	            modal: true
	        }).openDialog();

	};

	var initializeDatePickers = function() {
        var regional;

        if (typeof jQuery.datepicker.regional[AAcom.prototype.getProperty('userLocale')] == "undefined") {
            if (typeof jQuery.datepicker.regional[AAcom.prototype.getProperty('userLocale').substring(0,2)] == "undefined") {
                regional = jQuery.datepicker.regional[''];
            } else {
                regional = jQuery.datepicker.regional[AAcom.prototype.getProperty('userLocale').substring(0,2)];
            }
        } else {
            regional = jQuery.datepicker.regional[AAcom.prototype.getProperty('userLocale')];
        }

        $.datepicker.setDefaults(regional);

		$.datepicker.setDefaults({
		    disabled: false,
		    numberOfMonths: 2,
		    showButtonPanel: true,
		    closeText: AAcom.prototype.getProperty('closeTxt'),
		    minDate: 0,
		    maxDate: +331,
		    hideIfNoPrevNext: true,
		    showAnim: 'fadeIn',
		    buttonText: '',
		    showOn: 'both',
		});

		setReturnOnInput();
	};

	var setDatepickerHiddenText = function() {
		if($.datepicker.initialized) {
			var hiddenSpan = document.createElement('span');
			hiddenSpan.className = "hidden-accessible";
			var hiddenText = document.createTextNode(AAcom.prototype.getProperty('navigateCalendar'));
			hiddenSpan.appendChild(hiddenText);
			$('.ui-datepicker-trigger').append(hiddenSpan);
		}
	};

	var setReturnOnInput = function() {
		$("#departOnInput").datepicker({
			defaultDate: $("#departOnInput").val(),
            onSelect: function(dateText, inst) {
            	if(!$('#returnOnInput').hasClass("user-modified")) {
	                var dt = $.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), dateText);
	                dt.setDate(dt.getDate() + 7);
	                $('#returnOnInput').datepicker('setDate', dt);
            	}
            	$("#returnOnInput").datepicker("option", "minDate", $("#departOnInput").datepicker("getDate"));

            	if ($('#roundTrip option:selected').val() === 'false') {
            		disableReturnOnInput();
            	}
            }
        });

        // set drop off datepicker min date to pickup datepicker selected date
        $("#returnOnInput").datepicker({
        	minDate: $("#departOnInput").datepicker("getDate"),
        	defaultDate: $("#returnOnInput").val()
        });

        $("#returnOnInput").change(function() {
        	$(this).addClass("user-modified");
        });
        //set departure date as min date when user enters the date manually
        $("#departOnInput").change(function() {
        	$("#returnOnInput").datepicker("option", "minDate", $("#departOnInput").datepicker("getDate"));
        });
	};

	var oneWayDisablesReturnDate = function() {
		$('#roundTrip').change(function() {
			if ($('#roundTrip option:selected').val() === 'true') {
				$('#returnOnInput').removeAttr('disabled');
				$('#returnOnInput').next('button.ui-datepicker-trigger').removeAttr('disabled');
			} else {
				disableReturnOnInput();
			}
		});
	};

	var disableReturnOnInput= function() {
		$('#returnOnInput').val("");
		$('#returnOnInput').attr('disabled', 'true');
		$('#returnOnInput').next('button.ui-datepicker-trigger').attr('disabled', 'true');
	};

	var disableReturnIfOneWayIsSelected = function() {
		if ($('#roundTrip option:selected').val() === 'false') {
			disableReturnOnInput();
		}
	};

	/**
	 * Public Methods exposed to the others
	 */
	return {
        initializeHomepage : initializeHomepage
    };


}());
